// Import directly (not via the components barrel) so this fallback module does
// not transitively pull in MediaBlock -> smart-video -> ... (import cycle).
import { DefaultHtmlRenderer } from './shared/form-embed/components/default-html-renderer';
import type { LinkResolver } from './core/smart-link';

/**
 * Empty fallback components for optional custom integrations.
 * Used when a custom component doesn't exist in a project.
 *
 * Add new fallback exports here as needed for other optional components.
 */
export const FooterAdditionalContentTop = () => null;
export const FooterAdditionalContentBottom = () => null;
export const HeroAdvancedAdditionalContent: React.FC<{
  theme?: string;
  isDark?: boolean;
}> = () => null;
export const FormEmbedAdditionalContent: React.FC = () => null;
export const FormEmbedFormHandler: React.FC<{
  html: string | undefined | null;
  variant?: '1col' | '2col';
}> = ({ html }) => <DefaultHtmlRenderer html={html} />;
export const HtmlBlockFormHandler: React.FC<{
  html: string | undefined | null;
  containerRef: React.RefObject<HTMLElement | null>;
}> = () => null;

// Empty link resolvers array - used when no custom resolvers are defined
export const customLinkResolvers: LinkResolver[] = [];

// Noop consent manager - grants all consent (no consent tool configured)
export const consentManagerAdapter: import('@/app/_hooks/use-consent-manager').ConsentManagerAdapter = {
  checkConsent: () => true,
  openConsentDialog: () => {
    /* noop: no consent tool configured */
  },
  subscribe: () => () => {
    /* noop unsubscribe */
  },
  isAvailable: () => true,
  isConfigured: () => false,
  updateLanguage: () => {
    /* noop: no consent tool configured */
  },
};
